import React, { useState, useEffect, useContext } from "react";
import AddButton from "../../components/_default/AddButton";
import Icon from "../../components/_default/Icon";
import "./Exercises.scss";
import aurum from "../../assets/images/aurum.png";
import ExerciseList from "../../components/_exercises/ExerciseList";
import DropDown from "../../components/_default/DropDown";
import { getExercisesAurum, getExercisesCoach } from "../../services/firebase/firestore/getData";
import Spinner from "../../components/_default/Spinner";
import Popup from "../../components/_default/Popup";
import { deleteExerciseAurum, deleteExerciseCoach } from "../../services/firebase/firestore/deleteData";
import SearchPage from "../../components/_default/SearchPage";
import { deleteMediaArrayFromStorage } from "../../services/firebase/storage";
import UserContext from "../../services/context/userContext";
import sortAlphabetically from "../../services/defaultFunctions/sortAlphabetically";
import isIterable from "../../services/defaultFunctions/isIterable";
import { useCookies } from 'react-cookie';

import logo from '../../assets/images/logo.svg';

function Exercises(props) {
  const [cookies, setCookie] = useCookies(['from']);
  const _initial_categories = ["Upper", "Lower", "Core", "Plyometrics", "Remedial", "Mobility", "Cardio"];
  const [checked, setChecked] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [exercises, setExercises] = useState({ aurum: false, coach: false });
  const [initialExercises, setInitialExercises] = useState({ aurum: false, coach: false });
  const [from, setFrom] = useState(cookies.from ? cookies.from : "aurum");
  const [categories, setCategories] = useState({ aurum: false, coach: false });
  let url = new URL(window.location.href);
  const [searchValue, setSearchValue] = useState('');
  const [fulllist, setFulllist] = useState(false);
  let [loading,setLoading]=useState(true)
  const user = useContext(UserContext);

  const filters = ["Sort by name", "Sort by category"];
  const [filter, setFilter] = useState("Sort by name");
  const filterTypes = ["Ascending", "Descending"];
  const [filterType, setFilterType] = useState("Ascending");
  
  useEffect(() => {
    sorter({ ...exercises });
  }, [filter, filterType])

  useEffect(() => {
    // setLoading(false)
    getExercises();
  }, []);

  useEffect(() => {
    // set values from url params
    let search_params = url.searchParams;
    setSearchValue(search_params.get('search'));
    
    if(search_params.get('filter')) {
      setFilter(search_params.get('filter'))
    }
    if(search_params.get('filterType')) {
      setFilterType(search_params.get('filterType'));
    }
    if(search_params.get('categories')) {
      const myCategories = search_params.get('categories').split(";");
      setChecked(myCategories);

      getExercisesAurum((aurum_result) => {
        getExercisesCoach(user.id, (coach_result) => {
          let aurums = []
          if(aurum_result) {
            aurum_result.forEach(element => {
              if(search_params.get('search') === null) {
                if(myCategories.includes(element.category)) {
                  aurums.push(element)
                }
              }else if(search_params.get('search') !== null && element.name.toLowerCase().includes(search_params.get('search'))) {
                if(myCategories.includes(element.category)) {
                  aurums.push(element)
                }
              }
            });
          }else {
            aurums = false;
          }
          
          let coachs = [];
          if(coach_result) {
            coach_result.forEach(element => {
              if(search_params.get('search') === null) {
                if(myCategories.includes(element.category)) {
                  coachs.push(element)
                }
              }else if(search_params.get('search') !== null && element.name.toLowerCase().includes(search_params.get('search'))) {
                if(myCategories.includes(element.category)) {
                  coachs.push(element)
                }
              }
            });
          }else {
            coachs = false;
          }
          handleExercises({ aurum: { items: aurums, type: "aurum" }, coach: { items: coachs, type: "coach" } })
        });
      });
    }
  }, []);

  useEffect(() => {
    // debugger
    handleCheck(false);
    setCookie('from', from, { path: '/' });
  }, [from]);

  function removeExercise(e) {
    setLoading(true)
    let deleteUrlArray = [e.image, e.video_front, e.video_side];
    if (e.video_back) {
      deleteUrlArray.push(e.video_back);
    }
    deleteMediaArrayFromStorage(deleteUrlArray, () => {
      if(from === "aurum"){
        deleteExerciseAurum(e.id, () => {
          getExercises();
        });
      }else{
        deleteExerciseCoach(user.id, e.id, () => {
          getExercises();
          setShowPopup(false)
        });
      }
    });
  }

  function handleCheck(_category) {
    let _checked_categories = [...checked];

    if (_category) {
      if (_checked_categories.includes(_category)) {
        _checked_categories.splice(
          _checked_categories.findIndex((e) => e === _category),
          1
        );
      } else {
        _checked_categories.push(_category);
      }
      handleCategories(_checked_categories, initialExercises, from);
    } else {
      handleCategories([], initialExercises, from);
    } 
  }

  function handleCategories(_checked_categories, initial, type) {
    if (isIterable(initial[type])) {
      let _checked_exercises = [];
      if (_checked_categories.length > 0) {
        _checked_categories.map((item) => {
          _checked_exercises = _checked_exercises.concat(initial[type].filter((e) => e.category === item));
        });
      } else {
        _checked_exercises = initial[type];
      }
      let _exercises = { ...exercises };
      
      _exercises[type] = _checked_exercises;
      setExercises(_exercises);
    }
    setChecked(_checked_categories);
  }

  function getExercises() {
    // debugger
    getExercisesAurum((aurum_result) => {
      getExercisesCoach(user.id, (coach_result) => {
        // debugger
        setLoading(false)
        setFulllist({ aurum: { items: aurum_result, type: "aurum" }, coach: { items: coach_result, type: "coach" } });
        handleExercises({ aurum: { items: aurum_result, type: "aurum" }, coach: { items: coach_result, type: "coach" } });
      });
    });
  }

  function handleExercises(result) {
    // debugger
    let _filtered_by_category = { ...categories };
    let _exercises = { ...exercises };
    _exercises.aurum = result.aurum.items;
    _exercises.coach = result.coach.items;
    setInitialExercises(_exercises);
    setExercises(_exercises);
    if (checked.length > 0) {
      handleCategories(checked, _exercises, from);
    } else {
      setExercises(_exercises);
    }
    Object.values(result).map((item) => {
      let filtered_by_category = [];
      item.items && item.items.map((item) => {
          let _index = filtered_by_category.findIndex((e) => e.category === item.category);
          if (_index !== -1) {
            filtered_by_category[_index].count += 1;
          } else {
            filtered_by_category.push({ category: item.category, count: 1 });
          }
          return filtered_by_category;
        });
      
        sorter(_exercises);

      _initial_categories.map((item) => {
        let _index = filtered_by_category.findIndex((e) => e.category === item);
        if (_index === -1) {
          filtered_by_category.push({ category: item, count: 0 });
        }
      });

      return (_filtered_by_category[item.type] = filtered_by_category);
    });

    setCategories(_filtered_by_category);

    setShowPopup(false);
  }

  function sorter(exercises) {
    // debugger
      if(exercises.aurum) { 
        exercises.aurum.sort((a,b) => {
          let firstCheck = filter === "Sort by category"? a.category : a.name;
          let secondCheck = filter === "Sort by category"? b.category : b.name;
          if (firstCheck > secondCheck) {
            return filterType == "Ascending"? 1 : -1;
          }
          if (secondCheck > firstCheck) {
            return filterType == "Ascending"? -1 : 1;
          }
            return 0;
          });
      }
      if(exercises.coach) {
        exercises.coach.sort((a,b) => {
          let firstCheck = filter === "Sort by category"? a.category : a.name;
          let secondCheck = filter === "Sort by category"? b.category : b.name;
          if (firstCheck > secondCheck) {
            return filterType == "Ascending"? 1 : -1;
          }
          if (secondCheck > firstCheck) {
            return filterType == "Ascending"? -1 : 1;
          }
          return 0;
        });
      }
   
      setExercises(exercises);
  }

  function searchExerciseList(e) {
    // debugger
    setSearchValue(e);
    let search_params = url.searchParams;
    search_params.set('search', e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);

    if(fulllist){
      handleExercises(fulllist);
        let finalResult = { aurum: { items: [], type: "aurum" }, coach: { items: [], type: "coach" } };
        if(fulllist.aurum.items) {
          fulllist.aurum.items.map((item) => {
            if(item.name.toLowerCase().includes(e.toLowerCase())) {
              finalResult.aurum.items.push(item);
            }
          })
        }
        if(fulllist.coach.items) {
          fulllist.coach.items.map((item) => {
            if(item.name.toLowerCase().includes(e.toLowerCase())) {
              finalResult.coach.items.push(item);
            }
          })
        }
        if(e === "") {
          handleExercises(fulllist);
        }else {
          handleExercises(finalResult);
        }  
    }
    let _checked_categories = [...checked];

    if(_checked_categories && _checked_categories.length > 0){
      handleCategories(_checked_categories, initialExercises, from);
    }
    
  }

  function setFilterParam(e) {
    let search_params = url.searchParams;
    search_params.set('filter', e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  function setFilterTypeParam(e) {
    let search_params = url.searchParams;
    search_params.set('filterType', e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  function setParamsCategories(cat) {
    let _checked_categories = [...checked];

    if (_checked_categories.includes(cat)) {
      _checked_categories.splice(
        _checked_categories.findIndex((e) => e === cat),
        1
      );
    } else {
      _checked_categories.push(cat);
    }

    let checkedCats = "";
    _checked_categories.forEach(element => {
      if(checkedCats !== "") {
        checkedCats += ";";
      }
      checkedCats += element;
    })

    let search_params = url.searchParams;
    search_params.set('categories', checkedCats);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  return (
    <div className="c-page-wrapper c-page-dashboard c-page-exercises">
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav">
            <h1 className="c-header-title">Exercises</h1>
            <ul className="c-header-nav-wrapper">
              <li className={from === "aurum" ? "--active" : ""} onClick={() => setFrom("aurum")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
                <p>Aurum <span>({initialExercises.aurum.length})</span></p>
              </li>
              <li className={from === "coach" ? "--active" : ""} onClick={() => setFrom("coach")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
                  <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>
                </div>
                <p>{user.first_name} <span>({initialExercises.coach ? initialExercises.coach.length : 0})</span> </p>
              </li>
            </ul>
          </div>
          <div className="c-header-add">
            {/* fix button heading */}
            <AddButton text="New Exercise" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/exercise", { update: false, from: from })} />
          </div>
          <div className="c-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      <div className="c-page-wrapper--exercises">
        <div className="c-page-main--exercises">
          <div className="c-exercise-finder">
            <SearchPage placeholder="Search exercise" value={searchValue} onChange={(e) => { searchExerciseList(e.target.value)} } />
            <div className="c-dropdown-holder">
              <DropDown options={filters} value={filter} onChange={(e) => {setFilter(e); setFilterParam(e)}} />
              <DropDown options={filterTypes} value={filterType} onChange={(e) => {setFilterType(e); setFilterTypeParam(e)}} />
            </div>
          </div>

          <div className="c-side-options">
            <ul>
              {categories[from] &&
                _initial_categories.map((item, idx) => (
                  <li key={idx}>
                    <div className="checkbox" onClick={() => {handleCheck(item); setParamsCategories(item) }}>
                      <Icon icon={checked.includes(item) ? "checked" : "unchecked"} size={20} height={20} color={checked.includes(item) ? '#00B9A5' : "#979797"} />
                    </div>
                    <p>
                      {item} ({ categories[from].filter((e) => e.category === item)[0].count })
                    </p>
                  </li>
                ))}
              
            
            </ul>
          </div>

          {/* {!exercises ?  */}
          {loading ? 
            <div className="c-list-loader">
              <Spinner  size={50}/>
            </div>
           : (
            <ExerciseList history={props.history} from={from} exercises={exercises[from]} removeExercise={(e) => setShowPopup({ type: "exercise", ...e })} />
          )}
        </div>
      </div>
      {showPopup && (
        <Popup
          title={"Delete exercise"}
          button="Delete"
          deletePopup={true}
          description={"Are you sure you want to delete this exercise? This can not be undone."}
          onAction={() => removeExercise(showPopup)}
          // onAction={removeExercise}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
}

export default Exercises;
